const fontSizes = [
    '10px',
    '12px',
    '14px',
    '16px',
    '18px',
    '20px',
    '26px',
    '32px',
    '40px',
    '50px',
] as const;

const fontSizesMap = {
    xxxs: '13px', // 2
    xxs: '16px', // 2.4
    xs: '20px', // 3
    sm: '25px', // 3.2
    md: '30px', // 4
    lg: '40px', // 4.8
    xl: '48px', // 6
} as const;

const fontSizesMobileMap = {
    xxxs: '10px',
    xxs: '12px', // 1.6
    xs: '14px', // 2.1
    sm: '16px', // 2.4
    md: '18px', // 2.4
    lg: '22px', // 2.8
    xl: '26px', // 3.2
} as const;

export default {
    fontSizes,
    fontSizesMap,
    fontSizesMobileMap,
};
